import type { Project } from "graphql/generated";

/**
 * Picks the project to open: the saved selection if it is one of `projects`,
 * else the first project the user owns, else the first project. Returns
 * undefined for an empty list.
 */
export const selectBestProjectId = (
  projects: Pick<Project, "id" | "isOwner">[],
  selectedProjectId?: Project["id"],
): Project["id"] | undefined =>
  projects.find(({ id }) => id === selectedProjectId)?.id ??
  projects.find((p) => p.isOwner)?.id ??
  projects[0]?.id;
